import { generateHash } from "../services/payService";
import { payLinkStore } from "../../../store/payLinkStore";

export const usePay = () => {
    const { payLinkMateria, noPayCase,removePayLink } = payLinkStore();

    const getGeneratedHash = async (order: string, reference: string, amount: string) => {
        console.log("Entrando a Generated Hash");
        try {
            const payLink = await generateHash(order, reference, amount);
            
            noPayCase(payLink); // Solo actualiza si el enlace es válido
         
            console.log("Hash actualizado")
        } catch (err) {
            console.log("Error en Hooks", err);
        }
    };

    return {
        payLinkMateria,
        removePayLink,
        getGeneratedHash
    };
};

export const FormatCurrency = (value: any) => {
    return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2
    }).format(value);
}
